"use client";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { memo } from "react";
import { aboutUsHeroData } from "./constants";
import { AboutUsHeroProps } from "./types";

const AboutUsHero = ({ className, ...rest }: AboutUsHeroProps) => {
  const { title, description, imageUrl, imageDimensions } = aboutUsHeroData;
  return (
    <section
      className={cn(
        "overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero",
        className
      )}
      {...rest}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[minmax(0,259fr)_minmax(0,301fr)] lg:gap-0 lg:py-20">
          <div className="flex flex-col lg:justify-center gap-8 lg:max-w-[518]">
            <div className="grid grid-cols-1 place-content-start gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>{title}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{description}</p>
              </Typography>
            </div>
          </div>
          {imageUrl && (
            <div className="flex items-start">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width}
                height={imageDimensions?.height}
                className="flex-auto min-w-0"
                quality={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUsHero);
